module.exports = __webpack_public_path__ + "static/media/document-utilitybill.3ced5836.png";